var UgcBuilderComponent = {
  name: '_Ugc_',
  inputs: [{
    name: 'experienceName',
    type: 'string',
    defaultValue: null
  }]
};
export default UgcBuilderComponent;